import React from 'react';
import ItemPanelContent from '../../../../components-legacy/ItemPanel/ItemPanelContent';
import useUserStorePanel from '../../../../components-legacy/UserStorePanel/useUserStorePanel';
import useContext from '../../../../hooks/useContext';
import { StoreContext } from '../../../../providers/store';
import { BanIcon, CheckCircleIcon } from '../../../../styled/Icon';
import { IconContainer } from '../../../../styled/StatusIcon/wrappers';
import { Column, Columns } from '../../../../styled/Columns/wrappers';
import clsx from 'clsx';
import { ProductContext } from '../providers/ProductProvider';
import { useGetStoreStocksByGroupId } from '../../../../api/article/similarInStock';

interface IStatus {
  value: number;
}

const Status = ({ value }: IStatus) => {
  const isAvailable = value > 0;
  const statusText =
    value === 0
      ? 'Inga utföranden i butikslager'
      : value === 1
        ? '1 utförande i butikslager'
        : `${value} utföranden i butikslager`;

  return (
    <Columns className="valign-middle space-1">
      <Column>
        <IconContainer className={clsx(!isAvailable && 'unavailable')}>
          {isAvailable && <CheckCircleIcon />}
          {!isAvailable && <BanIcon />}
        </IconContainer>
      </Column>
      <Column>{statusText}</Column>
    </Columns>
  );
};

interface IVariantsInStockStatus {
  onStoreSelect: () => void;
}

export default function VariantsInStockStatus({ onStoreSelect }: IVariantsInStockStatus) {
  const { userStore, updateUserStore, loading: loadingUserStore } = useContext(StoreContext);

  const { showLoader, mappedStores, mappedAdjacentStores, selectableQuery, handleSearch } =
    useUserStorePanel(loadingUserStore, undefined, userStore?.storeId);

  const { groupId } = useContext(ProductContext);

  const handleStoreChange = (newStoreId: string) => {
    updateUserStore(newStoreId);
    onStoreSelect();
  };

  const { data: storeStocks, isLoading: loadingStoreStocks } = useGetStoreStocksByGroupId(groupId);

  const switchOptions = {
    switchLabel: 'Butiker med utföranden i butikslager',
    handleSwitch: (items: IPanelStore[]) =>
      items.filter((item: IPanelStore) => {
        const itemStatus = (storeStocks && storeStocks[item.id]) || 0;

        return itemStatus > 0;
      }),
    initialSwitchState: false,
  };

  return (
    <ItemPanelContent
      switchOptions={switchOptions}
      retainOnClose
      items={mappedStores}
      featuredItems={mappedAdjacentStores}
      featuredItemsLabels={{ featured: 'Butiker nära dig', general: 'Alla butiker' }}
      onSelect={handleStoreChange}
      selectedId={userStore?.storeId}
      selectedOnTop
      searchLabel="Ange ditt postnummer, stad eller butiksnamn"
      selectableQuery={selectableQuery}
      multipleActions
      renderStatus={(item) => <Status value={(storeStocks && storeStocks[item.id]) || 0} />}
      onSearch={handleSearch}
      noMatchText="Vi kunde tyvärr inte matcha någon butik med din sökfråga."
      loading={showLoader || loadingStoreStocks}
    />
  );
}
